module.exports = __webpack_public_path__ + "static/media/conlicitacao_academy.7a03d5a7.png";